// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__Swk6q","column":"Content_column__8Im8D","inner":"Content_inner__h_JYz"};